
<template>
  <div>
    <v-btn
      small 
      style="border-radius: 5px;" 
      :color="button.color" 
      @click="$emit('click')"
    >
      <v-icon :left="!show_more">{{ alt_icon ? alt_icon : button.icon }}</v-icon>
      {{alt_label ? alt_label : button.label}}
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'FButton',
  props: {
    save: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    show_more: {
      type: Boolean,
      default: false,
    },
    alt_label: {
      type: String,
      default: null,
    },
    alt_icon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    button(){
      if(this.save){
        return { label: "Salvar", color: "success", icon: "mdi-content-save" }
      }else if(this.close){
        return { label: "Fechar", color: "error", icon: "mdi-close"}
      }else if(this.edit){
        return { label: "Editar", color: "primary", icon: "mdi-pencil"}
      }else if(this.show_more){
        return { label: "Ver tudo", color: "info", icon: ""}
      }else{
        return {label: "", icon: "", color: "primary"}
      }
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>